import { render, staticRenderFns } from "./NegativacaoList.vue?vue&type=template&id=09b15ae7"
import script from "./NegativacaoList.vue?vue&type=script&lang=js"
export * from "./NegativacaoList.vue?vue&type=script&lang=js"
import style0 from "./NegativacaoList.vue?vue&type=style&index=0&id=09b15ae7&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports